"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PageAnalyticsController_1 = __importDefault(require("./PageAnalyticsController"));
var ProductListingPageAnalyticsController = /** @class */ (function (_super) {
    __extends(ProductListingPageAnalyticsController, _super);
    function ProductListingPageAnalyticsController(datalayerManager) {
        return _super.call(this, 'ACS result list', datalayerManager) || this;
    }
    ProductListingPageAnalyticsController.setSearchResults = function (resultsCount) {
        if (typeof resultsCount === 'number') {
            window.tracking.search.results = resultsCount.toString();
        }
    };
    ProductListingPageAnalyticsController.prototype.track = function (trackingAction) {
        if ('selectedFilter' in trackingAction.data) {
            PageAnalyticsController_1.default.setMappingForFilterNames(trackingAction.data.selectedFilter);
            PageAnalyticsController_1.default.setFilterEvent(trackingAction.data.selectedFilter);
            if (trackingAction.data.selectedFilter.filterName === 'rentOptionsDealer' && trackingAction.data.dealerData) {
                PageAnalyticsController_1.default.setDealerData(trackingAction.data.dealerData);
            }
        }
        else if ('eventType' in trackingAction.data) {
            if (trackingAction.data.eventType === 'searchResultsCount') {
                // set results Count
                ProductListingPageAnalyticsController.setSearchResults(trackingAction.data.eventValue);
            }
            else if (trackingAction.data.eventType === 'listSortingChange' &&
                trackingAction.data.eventValue instanceof Object &&
                'sortOrder' in trackingAction.data.eventValue) {
                //update sort order event
                PageAnalyticsController_1.default.sendEvent("ACS sort order ".concat(trackingAction.data.eventValue.sortOrder));
            }
            else if (trackingAction.data.eventType === 'loadMoreResults') {
                //Load More event
                PageAnalyticsController_1.default.sendEvent('ACS show more vehicles');
            }
            PageAnalyticsController_1.default.setSelectedFilters(trackingAction);
        }
        else if ('searchResultsCount' in trackingAction.data) {
            ProductListingPageAnalyticsController.setSearchResults(trackingAction.data.searchResultsCount);
        }
    };
    return ProductListingPageAnalyticsController;
}(PageAnalyticsController_1.default));
exports.default = ProductListingPageAnalyticsController;
